var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 30.3926V100.252L62.5 102.758L19.7368 100.252V30.3926H105.263Z",
    fill: "#FAEEE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 30.3926V100.252L62.5 102.758V30.3926H105.263Z",
    fill: "#DCD2CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5723 30.3925V102.744H62.5L59.8273 62.0306L62.5 30.3925L78.5362 19.7368L94.5723 30.3925Z",
    fill: "#EEBD40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5723 30.3925V102.744H78.5361V19.7368L94.5723 30.3925Z",
    fill: "#E5813E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 30.3925V102.744H30.4276V30.3925L46.4638 19.7368L62.5 30.3925Z",
    fill: "#EB6359"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 30.3925V102.744H46.4639V19.7368L62.5 30.3925Z",
    fill: "#C7364F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1908 89.2404H83.8816V102.744H73.1908V89.2404Z",
    fill: "#7F4245"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5361 89.2404H83.8815V102.744H78.5361V89.2404Z",
    fill: "#4D2131"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 89.2404H51.8092V102.744H41.1184V89.2404Z",
    fill: "#7F4245"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 89.2404H51.8093V102.744H46.4639V89.2404Z",
    fill: "#4D2131"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 67.8588H51.8092V78.5496H41.1184V67.8588Z",
    fill: "#FAEEE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 100.252H105.263V105.263H19.7368V100.252Z",
    fill: "#85D579"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 100.252H105.263V105.263H62.5V100.252Z",
    fill: "#509978"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1908 67.8586H83.8816V78.5494H73.1908V67.8586Z",
    fill: "#FAEEE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1908 46.4771H83.8816V57.1678H73.1908V46.4771Z",
    fill: "#FAEEE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1184 46.4772H51.8092V57.168H41.1184V46.4772Z",
    fill: "#FAEEE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0305 34.8459H81.0418V39.8573H76.0305V34.8459Z",
    fill: "#3B3957"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5361 34.8459H81.0418V39.8573H78.5361V34.8459Z",
    fill: "#241B38"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5361 46.4772H83.8815V57.168H78.5361V46.4772Z",
    fill: "#DCD2CD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5361 67.8588H83.8815V78.5496H78.5361V67.8588Z",
    fill: "#DCD2CD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9581 34.8459H48.9694V39.8573H43.9581V34.8459Z",
    fill: "#3B3957"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 34.8459H48.9695V39.8573H46.4639V34.8459Z",
    fill: "#241B38"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 46.4772H51.8093V57.168H46.4639V46.4772Z",
    fill: "#DCD2CD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4639 67.8588H51.8093V78.5496H46.4639V67.8588Z",
    fill: "#DCD2CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/tt.3fdaac6aa35d932e7d94bc6ee54c5d4b.svg";
export { ForwardRef as ReactComponent };